import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';
export { default as BigHoverActionPlaceholder } from './components/BigHoverAction/BigHoverActionPlaceholder';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "MailListViewBigHoverAction"*/ './lazyIndex'),
    { name: 'MailListViewBigHoverAction' }
);

import BigHoverActionBasePlaceholder from './components/BigHoverAction/BigHoverActionPlaceholder';
import type { BigHoverActionBaseProps } from './components/BigHoverAction/BigHoverActionBase';

// lazy components
export const BigHoverActionBase: LazyComponent<BigHoverActionBaseProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.BigHoverActionBase, BigHoverActionBasePlaceholder);
